export default "__VITE_ASSET__d99b1db2__"